module.exports = __webpack_public_path__ + "static/media/IntroGREEK.ab30fef4.vtt";